export function formatServiceData(flightLuggage: any, count: any, type: any) {

  const output = [];
  const selectedOptions = flightLuggage?.[type]?.filterSelectedOption || [];
  let outboundCount = 1;
  let inboundCount = 1;

  // Step 1: Extract all numeric prices with currency
  const priceEntries: any = [];

  selectedOptions?.map((option: any) => {
    ['outbound', 'inbound']?.map((dir) => {
      const priceStr = option?.[dir]?.BasePrice;
      if (priceStr) {
        const currency = priceStr?.match(/[A-Za-z]+/g)?.[0] || "";
        const amount = parseFloat(priceStr.replace(/[^\d.]/g, ""));
        if (!isNaN(amount)) {
          priceEntries?.push({ amount, currency });
        }
      }
    });
  });

  // Step 2: Find the highest price
  const highest = priceEntries?.reduce((prev: any, curr: any) =>
    curr?.amount > prev?.amount ? curr : prev,
    { amount: 0, currency: "GBP" } // default fallback
  );
  // highest price pass for all the outbound and inbound entries
  const highestPrice = `${highest?.currency}${highest?.amount.toFixed(2)}`;

  // First: Add all outbound entries
  for (let i = 0; i < count && i < selectedOptions?.length; i++) {
    const option = selectedOptions[i];
    if (option?.outbound) {
      const [org, dest] = option?.outbound?.OrgDest?.split("-");
      output.push({
        name: `${org}${dest}${outboundCount++}`,
        value: `${highestPrice}***pax_0_${i}***${option?.outbound?.BookingTravelerType}`
      });
    }
  }

  // Then: Add all inbound entries
  for (let i = 0; i < count && i < selectedOptions?.length; i++) {
    const option = selectedOptions[i];
    if (option?.inbound) {
      const [org, dest] = option?.inbound?.OrgDest?.split("-");
      output.push({
        name: `${org}${dest}${inboundCount++}`,
        value: `${highestPrice}***pax_0_${i}***${option?.inbound?.BookingTravelerType}`
      });
    }
  }

  return output;
}


export function extractOrderedKeys(flightLuggage: any, count: any, type: any) {
  const selectedOptions = flightLuggage?.[type]?.filterSelectedOption || [];
  const keys = [];

  // First: Outbound keys
  for (let i = 0; i < count && i < selectedOptions?.length; i++) {
    const key = selectedOptions[i]?.outbound?.Key;
    if (key) keys.push(key);
  }

  // Then: Inbound keys
  for (let i = 0; i < count && i < selectedOptions?.length; i++) {
    const key = selectedOptions[i]?.inbound?.Key;
    if (key) keys.push(key);
  }

  return keys;
}


export function generateSeatsDataArray(flightLuggage: any) {
  const seats: any = [];

  const processDirection = (directionSeats: any, directionKey: any) => {
    directionSeats?.forEach((seat: any, index: any) => {
      if (seat?.BasePrice === "N/A") return;

      const route = seat?.OrgDest?.replace("-", "") || `${directionKey.toUpperCase()}${index + 1}`;
      const name = `${route}${index + 1}`;
      const travelerType = seat?.BookingTravelerType?.split("-")[0] || "ADT";
      const price = seat?.BasePrice?.trim() || "GBP0.00";

      const value = `${seat?.SeatCode || ""}***${price}***pax_0_${index}***${travelerType}`;

      seats.push({ name, value });
    });
  };

  const outboundSeats = flightLuggage?.seatSelection?.outbound || [];
  const inboundSeats = flightLuggage?.seatSelection?.inbound || [];

  const hasValidSeat = [...outboundSeats, ...inboundSeats].some(seat => seat?.BasePrice !== "N/A");

  if (!hasValidSeat) return [];

  processDirection(outboundSeats, "outbound");
  processDirection(inboundSeats, "inbound");

  return seats;
}


export const extractSeatKeys = (
  flightLuggage: any,
) => {
  if (!flightLuggage?.seatSelection) return [];
  let seatKeys: string[] = [];


  const outboundSeats = flightLuggage.seatSelection.outbound || [];
  const inboundSeats = flightLuggage.seatSelection.inbound || [];
  seatKeys = [
    ...outboundSeats.map((seat: any) => seat?.Key
      // isJet2 ? seat?.key : seat?.Key
    ),
    ...inboundSeats.map((seat: any) => seat?.Key
      // isJet2 ? seat?.key : seat?.Key
    ),
  ].filter((key) => key); // Filter out null, undefined, empty strings

  if (!seatKeys.length) return [];

  return seatKeys;
};


export function formatBaggageNote(flightLuggage: any, count: any, type: any) {
  const output = [];
  const selectedOptions = flightLuggage?.[type]?.filterSelectedOption || [];
  let outboundCount = 1;
  let inboundCount = 1;

  // Step 1: Extract all numeric prices with currency
  const priceEntries: any = [];

  selectedOptions?.map((option: any) => {
    ['outbound', 'inbound']?.map((dir) => {
      const priceStr = option?.[dir]?.BasePrice;
      if (priceStr) {
        const currency = priceStr?.match(/[A-Za-z]+/g)?.[0] || "";
        const amount = parseFloat(priceStr.replace(/[^\d.]/g, ""));
        if (!isNaN(amount)) {
          priceEntries?.push({ amount, currency });
        }
      }
    });
  });

  // First: Add all outbound entries
  for (let i = 0; i < count && i < selectedOptions?.length; i++) {
    const option = selectedOptions[i];
    if (option?.outbound) {
      const [org, dest] = option?.outbound?.OrgDest?.split("-");
      output.push({
        name: `${option?.outbound?.BookingTravelerType}***${org}${dest}${outboundCount++}`,
        value: `${option.outbound?.text}`
      });
    }
  }

  // Then: Add all inbound entries
  for (let i = 0; i < count && i < selectedOptions?.length; i++) {
    const option = selectedOptions[i];
    if (option?.inbound) {
      const [org, dest] = option?.inbound?.OrgDest?.split("-");
      output.push({
        name: `${option?.inbound?.BookingTravelerType}***${org}${dest}${inboundCount++}`,
        value: `${option.inbound?.text}`
      });
    }
  }

  // 🔍 Check if all values are same
  const allSame = output.every((item) => item.value === output[0]?.value);

  return allSame ? [output[0]] : output;
}
